(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqs-and-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
    const accordions = document.querySelectorAll('.faq__item--accordion');

    accordions.forEach(function(accordion){

        const thisButton = accordion.querySelector('button');
        const thisContent = accordion.querySelector('.accordion__content');
        const thisContentContainer = accordion.querySelector('.accordion__content-container');
        thisButton.addEventListener('click', function(){
            let open = thisButton.getAttribute('aria-expanded');

            if(open == 'false'){
                thisButton.setAttribute('aria-expanded', true);
                thisButton.classList.add('open');
                thisContent.classList.remove('hidden');
                thisContent.removeAttribute('hidden');
                thisContent.style.height = (thisContentContainer.offsetHeight + 20) + 'px';
            }else{
                thisButton.setAttribute('aria-expanded', false);
                thisButton.classList.remove('open');
                thisContent.classList.add('hidden');
                thisContent.setAttribute('hidden', true);
                thisContent.style.height = '0px';
            }
        });

    });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faqs"] && !Shopify.designMode) return;
  try {
    
(function () {
    const accordions = document.querySelectorAll('.faq__item--accordion');

    accordions.forEach(function(accordion){

        const thisButton = accordion.querySelector('button');
        const thisContent = accordion.querySelector('.accordion__content');
        const thisContentContainer = accordion.querySelector('.accordion__content-container');
        thisButton.addEventListener('click', function(){
            let open = thisButton.getAttribute('aria-expanded');

            if(open == 'false'){
                thisButton.setAttribute('aria-expanded', true);
                thisButton.classList.add('open');
                thisContent.classList.remove('hidden');
                thisContent.removeAttribute('hidden');
                thisContent.style.height = (thisContentContainer.offsetHeight + 20) + 'px';
            }else{
                thisButton.setAttribute('aria-expanded', false);
                thisButton.classList.remove('open');
                thisContent.classList.add('hidden');
                thisContent.setAttribute('hidden', '');
                thisContent.style.height = '0px';
            }
        });

    });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const navToggle = document.querySelector('.nav-toggle');
        const mainNav = document.querySelector('.main-nav');
        const submenuToggles = mainNav ? Array.from(mainNav.querySelectorAll('.submenu-toggle')) : [];

    const findSubmenu = (toggle) => {
        const navItem = toggle.closest('.nav-item');
        return navItem ? navItem.querySelector('.submenu') : null;
    };

    const closeAllSubmenus = (exceptionToggle = null) => {
        submenuToggles.forEach((toggle) => {
            if (exceptionToggle && toggle === exceptionToggle) {
                return;
            }

            toggle.setAttribute('aria-expanded', 'false');
            const submenu = findSubmenu(toggle);
            if (submenu) {
                submenu.parentElement.classList.remove('active');
                submenu.classList.remove('is-open');
            }
        });
    };

    if (mainNav && navToggle) {
        navToggle.addEventListener('click', () => {
            const isExpanded = navToggle.getAttribute('aria-expanded') === 'true';
            navToggle.setAttribute('aria-expanded', String(!isExpanded));
            mainNav.classList.toggle('is-active');
            if (isExpanded) {
                closeAllSubmenus();
            }
        });
    }

    if (mainNav) {
        submenuToggles.forEach((toggle) => {
            toggle.addEventListener('click', (event) => {
                event.preventDefault();

                const submenu = findSubmenu(toggle);
                if (!submenu) {
                    return;
                }

                const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

                if (isExpanded) {
                    toggle.setAttribute('aria-expanded', 'false');
                    submenu.parentElement.classList.remove('active');
                    submenu.classList.remove('is-open');
                } else {
                    closeAllSubmenus(toggle);
                    toggle.setAttribute('aria-expanded', 'true');
                    submenu.parentElement.classList.add('active');
                    submenu.classList.add('is-open');
                }
            });
        });

        document.addEventListener('click', (event) => {
            const clickedToggle = event.target.closest('.submenu-toggle');
            const clickedNavLink = event.target.closest('.nav-link');
            const clickedInsideNav = event.target.closest('.main-nav');
            const clickedToggleButton = event.target.closest('.nav-toggle');

            if (!clickedInsideNav && !clickedToggleButton) {
                closeAllSubmenus();
                return;
            }

            if (clickedNavLink && !clickedToggle) {
                closeAllSubmenus();
            }
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape') {
                closeAllSubmenus();
            }
        });
    }

    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-trees"] && !Shopify.designMode) return;
  try {
    
    (function () {
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        var heroes = document.querySelectorAll('.hero-trees');
        if (!heroes || heroes.length === 0) return;

        // Store cleanup per hero so we can re-init on breakpoint changes.
        // (Avoids stacking duplicate listeners and ensures base transforms are recalculated.)
        var CLEANUP_KEY = '__heroTreesParallaxCleanup';

        function clamp(value, min, max) {
            return Math.min(max, Math.max(min, value));
        }

        function initHero(hero) {
            if (hero && typeof hero[CLEANUP_KEY] === 'function') {
                hero[CLEANUP_KEY]();
                hero[CLEANUP_KEY] = null;
            }

            var bg = hero.querySelector('.hero__trees-bg');
            var fg = hero.querySelector('.hero__trees-fg');
            if (!bg || !fg) return;

            // Ensure we read transforms from CSS (not a previous inline transform)
            bg.style.transform = '';
            fg.style.transform = '';

            var bgBaseTransform = window.getComputedStyle(bg).transform;
            var fgBaseTransform = window.getComputedStyle(fg).transform;
            if (bgBaseTransform === 'none') bgBaseTransform = '';
            if (fgBaseTransform === 'none') fgBaseTransform = '';

            var isDesktop = true;
            if (window.matchMedia) {
                isDesktop = window.matchMedia('(min-width: 1025px)').matches;
            }

            // Desktop (mouse-follow) should stay subtle; scroll mode should be stronger.
            var bgMax = isDesktop ? 20 : 100;   // px (further away)
            var fgMax = isDesktop ? 50 : 260;  // px (closer)

            var targetX = 0;
            var targetY = 0;
            var currentX = 0;
            var currentY = 0;
            var rafId = 0;

            function apply() {
                rafId = 0;

                currentX += (targetX - currentX) * 0.12;
                currentY += (targetY - currentY) * 0.12;

                bg.style.transform = bgBaseTransform + ' translate3d(' + (currentX * bgMax) + 'px,' + (currentY * bgMax) + 'px,0)';
                fg.style.transform = fgBaseTransform + ' translate3d(' + (currentX * fgMax) + 'px,' + (currentY * fgMax) + 'px,0)';

                if (Math.abs(targetX - currentX) > 0.001 || Math.abs(targetY - currentY) > 0.001) {
                    rafId = window.requestAnimationFrame(apply);
                }
            }

            function schedule() {
                if (!rafId) rafId = window.requestAnimationFrame(apply);
            }

            function onPointerMove(event) {
                if (!isDesktop) return;
                if (event.pointerType && event.pointerType !== 'mouse') return;

                var rect = hero.getBoundingClientRect();
                var x = (event.clientX - rect.left) / rect.width;
                var y = (event.clientY - rect.top) / rect.height;

                // map to -0.5..0.5, clamp to avoid jumps
                targetX = clamp(x - 0.5, -0.5, 0.5);
                targetY = clamp(y - 0.5, -0.5, 0.5);
                schedule();
            }

            function onLeave() {
                if (!isDesktop) return;
                targetX = 0;
                targetY = 0;
                schedule();
            }

            function updateFromScroll() {
                if (isDesktop) return;

                var rect = hero.getBoundingClientRect();
                var viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
                if (!viewportH) return;

                // Relative offset of hero center from viewport center, normalized.
                // Clamp to keep it subtle and stable.
                var heroCenterY = rect.top + rect.height / 2;
                var viewportCenterY = viewportH / 2;
                var offset = (heroCenterY - viewportCenterY) / viewportH;

                targetX = 0;
                targetY = clamp(offset, -0.5, 0.5);
                schedule();
            }

            function onScroll() {
                updateFromScroll();
            }

            function onResize() {
                updateFromScroll();
            }

            if (isDesktop) {
                hero.addEventListener('pointermove', onPointerMove, { passive: true });
                hero.addEventListener('pointerleave', onLeave, { passive: true });
            } else {
                window.addEventListener('scroll', onScroll, { passive: true });
                window.addEventListener('resize', onResize, { passive: true });
                updateFromScroll();
            }

            hero[CLEANUP_KEY] = function () {
                hero.removeEventListener('pointermove', onPointerMove);
                hero.removeEventListener('pointerleave', onLeave);
                window.removeEventListener('scroll', onScroll);
                window.removeEventListener('resize', onResize);

                if (rafId) {
                    window.cancelAnimationFrame(rafId);
                    rafId = 0;
                }

                targetX = 0;
                targetY = 0;
                currentX = 0;
                currentY = 0;

                bg.style.transform = '';
                fg.style.transform = '';
            };
        }

        function reinitAll() {
            for (var i = 0; i < heroes.length; i++) {
                initHero(heroes[i]);
            }
        }

        // Initial init
        reinitAll();

        // Re-init when crossing key responsive breakpoints
        var breakpoints = ['(min-width: 660px)', '(min-width: 1025px)', '(min-width: 1200px)'];
        for (var j = 0; j < breakpoints.length; j++) {
            var mq = window.matchMedia(breakpoints[j]);
            if (mq.addEventListener) {
                mq.addEventListener('change', reinitAll);
            } else if (mq.addListener) {
                mq.addListener(reinitAll);
            }
        }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-video-carousel"] && !Shopify.designMode) return;
  try {
    
    const carouselMain = document.querySelector('.video-carousel');
    const carouselSlider = document.querySelector('.video-carousel__inner');

    if (carouselMain && carouselSlider) {
        let isSliderDragging = false;
        let startSliderPos = 0;
        let startDragPos = 0;
        let currentSliderTranslate = 0;
        let animationSliderID;
        let hasMoved = false;
        let autoCarouselIntervalId = null;
        let videoModalTrigger = null;
        let slideWidth = 0;
        let slideStep = 0;
        let baseSlideCount = 0;
        let baseTrackWidth = 0;
        let leadingCloneCount = 0;

        const videoModalYt = document.querySelector('.modal__video');
        const videoModalWrapper = document.querySelector('.modal__video .videoWrapper');
        const videoBgYt = videoModalYt.querySelector('.modal__video-bg');
        const videoCloseYt = videoModalYt.querySelector('.modal__video-close');
        const handleSliderStart = touchSliderStart();

        initialiseInfiniteCarousel(0);

        carouselMain.addEventListener('dragstart', function(event) {
            event.preventDefault();
        });

        carouselMain.addEventListener('touchstart', handleSliderStart, { passive: false });
        carouselMain.addEventListener('touchend', touchSliderEnd);
        carouselMain.addEventListener('touchmove', touchSliderMove, { passive: false });
        carouselMain.addEventListener('mousedown', handleSliderStart);
        carouselMain.addEventListener('mouseup', touchSliderEnd);
        carouselMain.addEventListener('mousemove', touchSliderMove);
        carouselMain.addEventListener('mouseleave', touchSliderEnd);
        window.addEventListener('resize', handleCarouselResize);

        carouselSlider.addEventListener('click', function(event) {
            const carouselButton = event.target.closest('button.video-review__play-button');

            if (!carouselButton) {
                return;
            }

            event.preventDefault();

            if (hasMoved) {
                return;
            }

            videoModalTrigger = carouselButton;
            stopAutoCarousel();
            ToggleVideoYt('open', carouselButton.dataset.src || '');
        });

        startAutoCarousel();

        if (videoBgYt && videoCloseYt) {
            videoBgYt.addEventListener('click', function() {
                ToggleVideoYt('close', '');
            });

            videoCloseYt.addEventListener('click', function() {
                ToggleVideoYt('close', '');
            });
        }

        // Pause auto-carousel when keyboard focus enters or leaves the carousel
        carouselMain.addEventListener('focusin', function(event) {
            if (!carouselMain.contains(event.relatedTarget)) {
                stopAutoCarousel();
            }
        });

        carouselMain.addEventListener('focusout', function(event) {
            // Don't restart if focus moved into the video modal
            if (!carouselMain.contains(event.relatedTarget) && !videoModalYt.contains(event.relatedTarget)) {
                startAutoCarousel();
            }
        });

        // Arrow key navigation for the carousel
        carouselMain.addEventListener('keydown', function(event) {
            if (baseSlideCount < 2) {
                return;
            }

            if (event.key === 'ArrowRight') {
                event.preventDefault();
                stopAutoCarousel();
                if (normalizeCarouselPosition()) {
                    setCarouselSliderPosition(true);
                }
                currentSliderTranslate = getCenteredTranslate(Math.round(getCenteredSlidePosition()) + 1);
                normalizeCarouselPosition();
                setCarouselSliderPosition();
                updateActiveSlide();
                startAutoCarousel();
            } else if (event.key === 'ArrowLeft') {
                event.preventDefault();
                stopAutoCarousel();
                if (normalizeCarouselPosition()) {
                    setCarouselSliderPosition(true);
                }
                currentSliderTranslate = getCenteredTranslate(Math.round(getCenteredSlidePosition()) - 1);
                normalizeCarouselPosition();
                setCarouselSliderPosition();
                updateActiveSlide();
                startAutoCarousel();
            }
        });

        function initialiseInfiniteCarousel(activeIndex) {
            const existingSlides = Array.from(carouselSlider.querySelectorAll('.video-review'));
            const originalSlides = existingSlides.filter(function(slide) {
                return slide.dataset.clonedSlide !== 'true';
            });

            carouselSlider.querySelectorAll('[data-cloned-slide="true"]').forEach(function(clonedSlide) {
                clonedSlide.remove();
            });

            baseSlideCount = originalSlides.length;

            if (!baseSlideCount) {
                return;
            }

            slideWidth = originalSlides[0].offsetWidth;
            slideStep = slideWidth + getCarouselGap();
            baseTrackWidth = slideStep * baseSlideCount;
            leadingCloneCount = baseSlideCount;

            const prependFragment = document.createDocumentFragment();
            const appendFragment = document.createDocumentFragment();

            for (let index = leadingCloneCount; index > 0; index -= 1) {
                const sourceIndex = (baseSlideCount - (index % baseSlideCount)) % baseSlideCount;
                prependFragment.appendChild(createSlideClone(originalSlides[sourceIndex]));
            }

            for (let index = 0; index < leadingCloneCount; index += 1) {
                appendFragment.appendChild(createSlideClone(originalSlides[index % baseSlideCount]));
            }

            carouselSlider.prepend(prependFragment);
            carouselSlider.append(appendFragment);

            currentSliderTranslate = getCenteredTranslate(leadingCloneCount + activeIndex);
            setCarouselSliderPosition();
            updateActiveSlide();
        }

        function createSlideClone(slide) {
            const slideClone = slide.cloneNode(true);
            slideClone.dataset.clonedSlide = 'true';
            slideClone.setAttribute('aria-hidden', 'true');
            slideClone.setAttribute('inert', '');
            return slideClone;
        }

        function getCarouselGap() {
            const sliderStyles = window.getComputedStyle(carouselSlider);
            return parseFloat(sliderStyles.columnGap || sliderStyles.gap || '0') || 0;
        }

        function getSliderPositionX(event) {
            return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX;
        }

        function touchSliderStart() {
            return function(event) {
                if (baseSlideCount < 2) {
                    return;
                }

                stopAutoCarousel();
                startSliderPos = currentSliderTranslate;
                startDragPos = getSliderPositionX(event);
                isSliderDragging = true;
                animationSliderID = requestAnimationFrame(sliderAnimation);
            };
        }

        function touchSliderMove(event) {
            if (!isSliderDragging) {
                return;
            }

            const currentDragPos = getSliderPositionX(event);
            currentSliderTranslate = startSliderPos - (startDragPos - currentDragPos);

            if (Math.abs(startDragPos - currentDragPos) > 5) {
                hasMoved = true;
                event.preventDefault();
                carouselSlider.classList.add('grabbing');
            }
        }

        function touchSliderEnd() {
            if (!isSliderDragging) {
                return;
            }

            cancelAnimationFrame(animationSliderID);
            isSliderDragging = false;

            carouselSlider.classList.remove('grabbing');
            snapCarouselPosition();
            startAutoCarousel();

            window.setTimeout(function() {
                hasMoved = false;
            }, 300);
        }

        function sliderAnimation() {
            setCarouselSliderPosition();

            if (isSliderDragging) {
                animationSliderID = requestAnimationFrame(sliderAnimation);
            }
        }

        function getCenteredTranslate(slideIndex) {
            const slideCenter = (slideIndex * slideStep) + (slideWidth / 2);
            return (carouselMain.offsetWidth / 2) - slideCenter;
        }

        function getCenteredSlidePosition() {
            return ((carouselMain.offsetWidth / 2) - currentSliderTranslate - (slideWidth / 2)) / slideStep;
        }

        function getWrappedSlideIndex() {
            const centeredSlideIndex = Math.round(getCenteredSlidePosition()) - leadingCloneCount;
            return ((centeredSlideIndex % baseSlideCount) + baseSlideCount) % baseSlideCount;
        }

        function normalizeCarouselPosition() {
            const minIndex = leadingCloneCount - 0.5;
            const maxIndex = leadingCloneCount + baseSlideCount - 0.5;
            let centeredSlidePosition = getCenteredSlidePosition();
            let hasWrapped = false;

            while (centeredSlidePosition < minIndex) {
                currentSliderTranslate -= baseTrackWidth;
                centeredSlidePosition += baseSlideCount;
                hasWrapped = true;
            }

            while (centeredSlidePosition >= maxIndex) {
                currentSliderTranslate += baseTrackWidth;
                centeredSlidePosition -= baseSlideCount;
                hasWrapped = true;
            }

            return hasWrapped;
        }

        function snapCarouselPosition() {
            if (normalizeCarouselPosition()) {
                setCarouselSliderPosition(true);
            }

            currentSliderTranslate = getCenteredTranslate(Math.round(getCenteredSlidePosition()));
            normalizeCarouselPosition();
            setCarouselSliderPosition();
            updateActiveSlide();
        }

        function autoAnimateCarousel() {
            if (isSliderDragging || baseSlideCount < 2) {
                return;
            }

            if (normalizeCarouselPosition()) {
                setCarouselSliderPosition(true);
            }

            currentSliderTranslate = getCenteredTranslate(Math.round(getCenteredSlidePosition()) + 1);
            setCarouselSliderPosition();
            updateActiveSlide();
        }

        function startAutoCarousel() {
            if (autoCarouselIntervalId !== null || baseSlideCount < 2) {
                return;
            }

            autoCarouselIntervalId = window.setInterval(autoAnimateCarousel, 4000);
        }

        function stopAutoCarousel() {
            if (autoCarouselIntervalId === null) {
                return;
            }

            window.clearInterval(autoCarouselIntervalId);
            autoCarouselIntervalId = null;
        }

        function handleCarouselResize() {
            if (!baseSlideCount) {
                return;
            }

            const activeIndex = getWrappedSlideIndex();
            initialiseInfiniteCarousel(activeIndex);
        }

        function updateActiveSlide() {
            const allSlides = carouselSlider.querySelectorAll('.video-review');
            const centeredIndex = Math.round(getCenteredSlidePosition());

            allSlides.forEach(function(slide, index) {
                slide.classList.toggle('active', index === centeredIndex);
            });
        }

        function setCarouselSliderPosition(withoutTransition) {
            if (withoutTransition) {
                carouselSlider.classList.add('is-resetting');
                carouselSlider.style.transform = `translateX(${currentSliderTranslate}px)`;
                carouselSlider.offsetHeight;
                carouselSlider.classList.remove('is-resetting');
                return;
            }

            carouselSlider.style.transform = `translateX(${currentSliderTranslate}px)`;
        }

        function videoModalFocusTrapHandler(event) {
            if (event.key === 'Escape') {
                ToggleVideoYt('close', '');
                return;
            }

            if (event.key !== 'Tab') {
                return;
            }

            const focusableSelectors = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
            const focusableElements = Array.from(videoModalYt.querySelectorAll(focusableSelectors))
                .filter(function(el) { return !el.closest('[inert]') && el.offsetParent !== null; });

            if (!focusableElements.length) {
                event.preventDefault();
                return;
            }

            const firstFocusable = focusableElements[0];
            const lastFocusable = focusableElements[focusableElements.length - 1];

            if (!videoModalYt.contains(document.activeElement)) {
                event.preventDefault();
                firstFocusable.focus();
                return;
            }

            if (event.shiftKey) {
                if (document.activeElement === firstFocusable) {
                    event.preventDefault();
                    lastFocusable.focus();
                }
            } else {
                if (document.activeElement === lastFocusable) {
                    event.preventDefault();
                    firstFocusable.focus();
                }
            }
        }

        function ToggleVideoYt(action, videoSrc) {
            if (action === 'open') {
                videoModalWrapper.innerHTML = '<iframe width="560" height="315" src="' + videoSrc + '" title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>';

                videoModalYt.removeAttribute('inert');
                videoModalYt.setAttribute('aria-hidden', 'false');
                videoModalYt.classList.add('show');

                document.addEventListener('keydown', videoModalFocusTrapHandler);

                videoCloseYt.focus();
            } else {
                videoModalYt.classList.remove('show');
                videoModalYt.setAttribute('aria-hidden', 'true');
                videoModalYt.setAttribute('inert', '');
                videoModalWrapper.innerHTML = '';

                document.removeEventListener('keydown', videoModalFocusTrapHandler);

                if (videoModalTrigger) {
                    videoModalTrigger.focus();
                    videoModalTrigger = null;
                }

                startAutoCarousel();
            }
        }
    }

    const videoBtns = document.querySelectorAll('.btn__play');
    const videoModal = document.querySelector('#video_modal');
    const videoEl = videoModal.querySelector('video');
    const videoBg = videoModal.querySelector('.modal__video-bg');
    const videoClose = videoModal.querySelector('.modal__video-close');

    videoBtns.forEach(function(videoBtn){
        if(videoModal){

        videoBtn.addEventListener("click", function(e) {
            e.preventDefault();
            const videoUrl = this.dataset.src;
            if(videoEl){
                videoEl.src = videoUrl;
                ToggleVideo();        
                videoEl.play();
            }
        });

        }
    });

    if(videoBg && videoClose) {

        videoBg.addEventListener("click", function() {
        if(videoEl){
            videoEl.pause();
            ToggleVideo();
        }
        });

        videoClose.addEventListener("click", function() {
        if(videoEl){
            videoEl.pause();
            ToggleVideo();
        }
        });

    }

    function ToggleVideo() {
        videoModal.classList.toggle('show');
    }

  } catch(e) { console.error(e); }
})();
})();
